<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="40%">
      <template v-slot:activator="{ on }">
        <v-btn color="primary background--text" dark v-on="on"> {{$t('my_account.add_device.title')}} </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline secondary--text lighten-2" primary-title>
          {{$t('my_account.add_device.title')}}
        </v-card-title>

        <v-card-text class="secondary--text">
          {{ $t("my_account.add_device.description") }}
          <v-form ref="form" onsubmit="return false;" class="pa-3">
            <v-text-field
              outline
              id="short_code"
              color="secondary"
              :label="$t('my_account.add_device.input.code.label')"
              name="short_code"
              placeholder="Enter 6 digit code"
              prepend-inner-icon="lock"
              type="text"
              :rules="[rules.required, rules.exact_length(6)]"
              v-model="short_code"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="resetAndCloseDialog"> {{$t('my_account.cancel')}} </v-btn>
          <v-btn color="success" flat @click="verifyShortCode"> {{$t('my_account.verify')}} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import rules from "@/validation";
export default {
  data() {
    return {
      rules,
      dialog: false,
      short_code: '',
    };
  },
  watch:{
    short_code: function(){
      this.short_code = this.short_code.toUpperCase();
    }
  },
  methods: {
    verifyShortCode() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$emit("verifyShortCode", {
        short_code: this.short_code,
      });
      this.resetAndCloseDialog();
    },

    resetAndCloseDialog() {
      (this.short_code = null), (this.dialog = false);
    },
  },
};
</script>
